module.exports = __webpack_public_path__ + "static/img/numbers_icon_local.d7af8b25.png";